class AddEmployeeModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    "ngInject";
    this.name = 'AddEmployeeModal';
    this.$http = $http;
    this.$rootScope = $rootScope;
    let self = this;
  }
}

export default AddEmployeeModalController



// WEBPACK FOOTER //
// ./client/common/modals/addEmployeeModal/addEmployeeModal.controller.js